'use client';

import { c as _c } from "react/compiler-runtime";
import { CareerAcceleratorsByCourseIds } from '@udemy-v2/career-accelerators';
import React, { createContext, useContext, ReactNode } from 'react';
const CourseCareerAcceleratorContext = createContext<CareerAcceleratorsByCourseIds | undefined>(undefined);
interface CourseCareerAcceleratorProviderProps {
  children: ReactNode;
  courseCareerAccelerator?: CareerAcceleratorsByCourseIds;
}
export function CourseCareerAcceleratorProvider(t0) {
  const $ = _c(3);
  const {
    children,
    courseCareerAccelerator
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== courseCareerAccelerator) {
    t1 = <CourseCareerAcceleratorContext.Provider value={courseCareerAccelerator}>{children}</CourseCareerAcceleratorContext.Provider>;
    $[0] = children;
    $[1] = courseCareerAccelerator;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function useCourseCareerAccelerator() {
  return useContext(CourseCareerAcceleratorContext);
}